<section class="users-view">
  <!-- Media object starts -->
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="media d-flex align-items-center">
        <!-- <a href="javascript:;">
          <img 
            [src]="imageUrl + userData?.image"
            alt="user view
            avatar"
            class="users-avatar-shadow rounded"
            height="64"
            width="64"
          />
        </a> -->
          <div *ngIf="userData?.image">
            <img class="users-avatar-shadow rounded mr-1" [src]="userData?.image"
              height="64" width="64" alt="datatable-avatar">
          </div>
          
            <div *ngIf="!userData?.image" [class.initial-alpha]="!userData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
              <div class="avatar-content">{{ userData?.name | shortName }}</div>
            </div>

        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{ userData?.name }}</span>
            <!-- <span class="text-muted font-medium-1">
                <span>@</span>
                <span class="users-view-username">dean3004</span>
              </span> -->
          </h4>
          <!-- <span class="mr-1">ID:</span>
          <span class="users-view-id">{{
            userData?._id
          }}</span> -->
        </div>
      </div>
    </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
      <a
      [routerLink]="['/users-edit', userData?.id]"
      (click)="editUser(userData?.id)"
        class="btn btn-sm btn-primary px-3 py-1" 
          >Edit</a
      >
    </div>  
  </div>
  <!-- Media object ends -->

  <div class="row">
    <div class="col-12">
      <!-- User detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Personal Info
              </h5>
              <div class="table-responsive">
                <table class="table table-borderless m-0">
                  <tbody>
                    <tr>
                      <td>Name:</td>
                      <td class="users-view-username">{{ userData?.name }}</td>
                    </tr>
                    <tr>
                      <td>E-mail:</td>
                      <td>{{ userData?.email }}</td>
                    </tr>
                    <tr>
                      <td>Date Of Birth:</td>
                      <td>{{ userData?.dob | date:'mediumDate'}}</td>
                    </tr>
                    <tr>
                      <td>Gender:</td>
                      <td>{{ userData?.sex| titlecase }}</td>
                    </tr>
                    <tr>
                      <td>Contact:</td>
                      <td>{{ userData?.phone}}</td>
                    </tr>
                    <!-- <tr>
                      <td>Status:</td>
                      <td>
                        <span class="badge bg-light-success">{{
                          userData?.status | titlecase
                        }}</span>
                      </td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- User detail ends -->
    </div>
    <div class="col-12" >
      
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <!-- <i class="ft-info mr-2"></i>  -->
              </h5>
              <div class="table-responsive">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>LinkedIn:</td>
                      <td>{{ userData?.linkedIn}} </td>
                    </tr>
                    <tr>
                      <td>Registered:</td>
                      <td>{{ userData?.created_at | date: "mediumDate" }}</td>
                    </tr>
                    <tr>
                      <td>Latest Activity:</td>
                      <td >
                        {{ userData?.updated_at | date: "mediumDate" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </div>

    <!-- <div class="col-12" *ngFor="let course of courses">
      
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Course Info
              </h5>
              <div class="table-responsive">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>Course:</td>
                      <td class="users-view-username">
                        {{ course.courseName }}
                      </td>
                    </tr>
                    <tr>
                      <td>Durations:</td>
                      <td class="users-view-username">
                        {{ course.durations }}
                      </td>
                    </tr>
                    <tr>
                      <td>Fees:</td>
                      <td class="users-view-username">
                        {{ course.fees }}
                      </td>
                    </tr>
                    <tr>
                      <td>Benifits:</td>
                      <td *ngIf="course.benfits.length>0" [innerText]="course.benfits" class="users-view-username">
                        
                      </td>
                    </tr>
                    <tr>
                      <td>OverView:</td>
                      <td [innerText]="course.overView" class="users-view-username">
                      </td>
                    </tr>
                    <tr>
                      <td>PreKnowledge:</td>
                      <td class="users-view-username">
                        {{ course.preKnowledge}}
                      </td>
                    </tr>
                    <tr>
                      <td>Who Should Join:</td>
                      <td class="users-view-username">
                        {{ course.whoShouldJoin}}
                      </td>
                    </tr>
                    <tr>
                      <td>Announcements:</td>
                      <td class="users-view-username">
                        {{ course.announcements}}
                      </td>
                    </tr>
                    <tr>
                      <td>Qualification:</td>
                      <td class="users-view-username">
                        {{ userData?.lastQualification }}
                      </td>
                    </tr>
                    <tr>
                      <td>Registered:</td>
                      <td>{{ userData?.createdOn | date: "mediumDate" }}</td>
                    </tr>
                    <tr>
                      <td>Latest Activity:</td>
                      <td class="users-view-latest-activity">
                        {{ userData?.updatedOn | date: "mediumDate" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </div> -->
    

<!-- <div class="col-12" *ngFor="let batch of batches">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <div class="col-12">
          <h5 class="mb-2 text-bold-500">
            <i class="ft-info mr-2"></i> Batch Info
          </h5>
          <div class="table-responsive">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <td>Batch:</td>
                  <td class="users-view-username">
                    {{ batch?.name }}
                  </td>
                </tr>
                <tr>
                  <td>Type:</td>
                  <td class="users-view-username">
                    {{ batch?.batchType }}
                  </td>
                </tr>
                <tr>
                  <td>Duration:</td>
                  <td>{{batch?.duration }}</td>
                </tr>
                <tr>
                  <td>Notes:</td>
                  <td class="users-view-latest-activity">
                    {{ batch?.notes }}
                  </td>
                </tr>
                <tr *ngIf="batch.batchType == 'online'">
                  <td>Joining Link:</td>
                  <td class="users-view-latest-activity">
                    {{ batch?.joiningLink }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div> -->

    <!-- <div class="col-12">
    
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i class="ft-info mr-2"></i> Transaction Info
              </h5>
              <div class="table-responsive">
                <table class="table mb-0" *ngIf="transactionData?.length">
                  <thead>
                    <tr>
                      <th>Total Fee</th>
                      <th>Paid Fee</th>
                      <th>Pending Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span>{{
                          transactionData?.totalFee | currency: "INR":"symbol"
                        }}</span>
                      </td>
                      <td>
                        <span class="badge bg-light-success">{{
                          transactionData?.paidFee | currency: "INR":"symbol"
                        }}</span>
                      </td>
                      <td>
                        <span class="badge bg-light-danger">{{
                          transactionData?.pendingFee | currency: "INR":"symbol"
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  *ngIf="!transactionData?.paidFee"
                  class="row bg-primary bg-lighten-4 rounded mx-1 text-center p-1 justify-content-center"
                >
                  <p class="mt-1">Data not found.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div> -->
  </div>
</section>
